export const getUserTrackingData = (user) => ({
  id: user.id,
  uuid: user.uuid,
  email: user.email,
  created_at: user.created_at
});
